import { firestoreRef, functionsRef } from "api";

export async function getPricingPlans() {
  return (await firestoreRef.collection("pricing_plans").get()).docs.map(d => d.data());
}

export async function verifyKhaltiPayment(payload, selectedPlan) {
  return (await functionsRef.httpsCallable("validateKhaltiPurchase")({
    khalti: payload,
    plan: selectedPlan
  })).data;
}
